<template>
	<div>
		<!-- 子路由出口：用于显示订单详情等子页面 -->
		<router-view 
		      v-if="$route.path.includes('orderDatalis') || $route.path.includes('Reviewdatails') || $route.path.includes('message') || $route.path.includes('AddMessage') || $route.path.includes('orderInvoice') ||  $route.path.includes('InitiateReview')">
			  </router-view>
		<!-- 订单列表：当不在详情页时显示 -->
		<template v-else>
			<div class="navlist">
				<ul>
					<li v-for="(i,Index) in navlist" 
					  :key='Index'
					  :class="{'classType':Index==navindex}" 
					   @click="tobnav(Index)"
					>
				    {{i.name}}
					<div v-if="Index==navindex"></div>
					</li>
				</ul>
				<div class="navso">
					<div class="soinput">
					  <i class="el-icon-search"></i>
					  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
					</div>
					<button @click="gxdata">搜索</button>
				</div>
			</div>
			<demandOrderList :list="list" @gengxin="gngxin"></demandOrderList>
			<div class="fenye" v-if="total>9">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :current-page.sync="currentPage1"
				 :page-size="9"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
		</template>
	</div>
</template>

<script>
	import {OrderIndex} from "@/api/api"
	import demandOrderList from '@/common/demandOrderList.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		 demandOrderList  
	  },
	  data() {
	    return {
		   keyword:"",
		   navindex:0,
		   navnumber:1,
		   navlist:[
			   {name:"全部"},
			   {name:"待付款"},
			   {name:"进行中"},
			   {name:"待评价"},
			   {name:"已完成"},
			   {name:"已取消"},
			   {name:"已收藏"}
		   ],
		   page:1,
		   status:"",
		   score:"",
		   list:[],
		   currentPage1:"",
		   pagecount:"",
		   total:""
	    }
	  },
	  watch: {
	    // 从子页（详情/邀请）返回时刷新列表
	    '$route'(to) {
	        this.getOrderIndex()
	    }
	  },
	  created() {
	  	 this.getOrderIndex()
	  },
	  methods: {
		handleCurrentChange(e){
			this.page=e
			this.getOrderIndex()
		},
		gngxin(){
			this.tobnav(this.navindex)
		},
		gxdata(){
			this.page=1
			this.getOrderIndex()
		},
		tobnav(index){
			this.navindex=index
			if(this.navindex<=5){
				switch(this.navindex) {
				    case 0:
				        this.status = "";
						this.score = ""
				        break;
				    case 1:
				        this.status = "0";
						 this.score = ""
				        break;
				    case 2:
				        this.status = "1,2,3,4";
						 this.score = ""
				        break;
				    case 3:
				        this.status = "5";
				        this.score = 0;
				        break;
				    case 4:
				        this.status = "5";
				        this.score = "1";
				        break;
				    case 5:
				        this.status = "-1";
				        this.score = "";
				        break;
				}
				this.page=1
				this.getOrderIndex()
			}else{
				this.page=1
				this.getcallOrderIndex()
			}
		},
		getOrderIndex(){
			OrderIndex({
				status:this.status,
				keyword:this.keyword,
				page:this.page,
				limit:'9',
				score:this.score
			}).then(res=>{
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
				this.list=res.data.data.data
			})
		},
		getcallOrderIndex(){
			OrderIndex({
				status:'',
				keyword:this.keyword,
				page:this.page,
				is_collect:"1",
				limit:'10',
				score:this.score
			}).then(res=>{
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
				this.list=res.data.data.data
			})
		}
	  }
	}
</script>

<style scoped>
	.navlist{
		width:1200px;
		margin:0 auto;
		height: 48px;
		border-radius: 12px;
		margin-top:24px;
		margin-bottom:24px;
		padding:8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.navlist ul{
		display:flex;
		align-items:center;
	}
	.navlist li{
		margin-right:16px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		cursor:pointer;
		position:relative;
		padding-bottom:10px;
	}
	.navlist li>div{
		position:absolute;
		width:20px;
		height:3px;
		border-radius:3px;
		background-color: #1E3A8A;
		margin-left: -10px;
		left: 50%;
		bottom: 0;
	}
	.navso{
		width: 360px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding: 7px 8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.soinput{
		display:flex;
		align-items:center;
	}
	.navso input{
		width:270px;
		border:none;
		outline:none;
		margin-left:5px;
	}
	.navso button{
		width:60px;
		height:32px;
		background: #1E3A8A;
		border-radius: 6px;
		color:#fff;
		border:none;
		outline: none;
		font-weight: 400;
		font-size: 12px;
		cursor: pointer;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
	}
	.classType{
		color: #1E3A8A !important;
	}
</style>